import { RouterProvider } from "react-router-dom";
import MFEContainer from "./containers/MFEContainer";
import { UserInfo } from "./types/UserInfo";
import { Router } from "@remix-run/router";
import UserContext from "./contexts/UserContext";
import { MixPanelType } from "./types/CommonTypes";

export interface Props {
  language: string;
  userInfo: UserInfo;
  router: Router;
  MixPanel: MixPanelType;
}

function App({ language, userInfo, router, MixPanel }: Props) {
  return (
    <MFEContainer language={language} MixPanel={MixPanel}>
      <UserContext userInfo={userInfo}>
        <RouterProvider router={router} />
      </UserContext>
    </MFEContainer>
  );
}

export default App;
